import { requestHeaders } from '@/api';
import { API_URL } from '@/data/service/dataService';
import { useMutation } from '@tanstack/react-query';

export interface SendInvoiceResponse {
  success: boolean;
}

const sendInvoice = async (url: string, consultationCode: string): Promise<void> => {
  const payload = {
    consultation_code: consultationCode
  };

  try {
    const response = await fetch(`${API_URL}/${url}`, {
      method: 'POST',
      headers: requestHeaders(),
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      throw new Error('Failed to send invoice');
    }

    const responseData = await response.json();
    if (!responseData?.success) {
      throw new Error('Failed to send invoice');
    }

    return;
  } catch (_err) {
    throw new Error('Error sending invoice');
  }
};

export const useSendInvoice = () => {
  const { mutateAsync, isError, isSuccess } = useMutation<void, Error, { consultationCode: string }>({
    mutationFn: ({ consultationCode }) => sendInvoice('consultation/mail/resendinvoice', consultationCode)
  });

  return {
    sendInvoice: mutateAsync,
    isError: isError,
    isSuccess: isSuccess
  };
};
